// @ts-nocheck
import * as React from 'react';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { CloseButton } from './feedback/dialog/CloseButton';
import Typography from '@mui/material/Typography';
import CircularIndeterminate from './CircularIndeterminate';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from "@mui/material/Divider";

const Root = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '56%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  overflow: "auto",
  boxShadow: 24,
  padding: '3%',
  p: 4,
  backgroundColor: '#fff',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    height: '100%',
  },
  [theme.breakpoints.up('md')]: {
    width: '80%',
    top: '50%',
    height: '80%',
  },
  [theme.breakpoints.down('md')]: {
    padding: '13%',
  },
  [theme.breakpoints.up('lg')]: {
    width: 960,
    height: '80%',
  },
}));

export function ModalGeneral({ Contenido, open, onClose, titulo = null, load = false, subtitulo = null }) {

  const contentRef = React.useRef(null);

  React.useEffect(() => {
    if (open)
      if (contentRef.current)
        contentRef.current.scrollIntoView({ behavior: 'smooth' });

  }, [open, load]);

  return (
    <>
      <Box>
        <Modal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          disableAutoFocus={true}
          disableEnforceFocus={true}
        >
          <Root >
            {load ? <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <div ref={contentRef} />
              <CircularIndeterminate /> </Grid>
              :
              <>
                <Grid container spacing={2}>
                  <div ref={contentRef} />
                  <Grid item xs={12}>
                    <CloseButton onClose={() => onClose()} />
                  </Grid>
                  {titulo ?
                    <Grid item xs={12}>
                      <Typography variant="h5" gutterBottom component="div">
                        {titulo}
                      </Typography>
                      <Typography variant="subtitle2" color='secondary' gutterBottom component="div">
                        {subtitulo}
                      </Typography>
                      <Divider />
                    </Grid> :
                    null
                  }
                  <Grid item xs={12}>
                    {Contenido}
                  </Grid>
                </Grid>
              </>
            }
          </Root>
        </Modal>
      </Box>
    </>
  );
}